module.exports = __webpack_public_path__ + "img/forget-pwd-left-bg-image.250b97c4.png";